import React, { useState, useRef } from "react";
import Card from "../../../modules/Card";
import PasswordToggle from "../../../modules/PasswordToggle";
import Spinner from "../../../modules/Spinner";
import { useTranslation } from "react-i18next";

const PasswordInputScreen = ({ onNext, isLoading }) => {
  const [error, setError] = useState("");

  const passwordRef = useRef();
  const confirmPasswordRef = useRef();
  const { t } = useTranslation();

  const handleError = () => {
    if (!error) return;
    const password = passwordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;
    if (password !== confirmPassword) {
      setError(t("enter_same_password"));
    } else setError("");
  };

  const handleSubmit = () => {
    const password = passwordRef.current.value;
    const confirmPassword = confirmPasswordRef.current.value;

    // "ROUTE_ERROR:Password must contain minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character"
    if (password !== confirmPassword) {
      setError(t("enter_same_password"));
    } else {
      onNext(password);
    }
  };

  return (
    <div className=" px-6 mt-10 ">
      <div className="flex flex-col items-center gap-0.5 justify-center">
        <p className="font-custom  text-2xl font-semibold text-[#7953D2] ">
          {t("create_password")}!
        </p>
        <p className="font-custom text-sm text-xs font-medium text-dark_gray ">
          {t("set_your_password")}
        </p>
      </div>

      <Card>
        <div className="flex flex-col gap-5">
          <PasswordToggle
            label="Password"
            placeholder="Enter your password"
            ref={passwordRef}
            onChange={handleError}
          />
          <PasswordToggle
            label="Confirm  Password"
            placeholder="Enter your password again"
            ref={confirmPasswordRef}
            error={error}
            onChange={handleError}
          />
        </div>

        <div className="mt-8">
          <button
            onClick={handleSubmit}
            className="font-custom btn btn-block bg-[#492897] text-white rounded-[30px] text-base font-semibold"
            disabled={error !== ""}
          >
            {isLoading ? (
              <Spinner heightResponsive />
            ) : (
              <span>{t("continue")}</span>
            )}
          </button>
        </div>
      </Card>
    </div>
  );
};

export default PasswordInputScreen;
